import { NgModule } from '@angular/core';
import { AgrSharedModule } from '@next/core-lib/shared';

@NgModule({
  declarations: [
    // add shared components here
  ],
  imports: [
    AgrSharedModule,
    // add shared modules here
  ],
  exports: [
    AgrSharedModule,
    // add shared modules here
  ],
  providers: [
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {}
